import { render, staticRenderFns } from "./LimitsRefreshButton.vue?vue&type=template&id=503f6842&scoped=true&"
import script from "./LimitsRefreshButton.vue?vue&type=script&lang=js&"
export * from "./LimitsRefreshButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503f6842",
  null
  
)

export default component.exports